import { render, staticRenderFns } from "./TusAsientosComponent.vue?vue&type=template&id=2c0a04da"
import script from "./TusAsientosComponent.vue?vue&type=script&lang=js"
export * from "./TusAsientosComponent.vue?vue&type=script&lang=js"
import style0 from "./TusAsientosComponent.vue?vue&type=style&index=0&id=2c0a04da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports